import { MessageBody, type MessageBodyData } from './MessageBody';
import { AssistantHeader } from './AssistantHeader';

export interface Message extends MessageBodyData {
  id: string;
  role: 'user' | 'assistant';
}

/**
 * Each row sits inside a centered `.message-row` column capped at 880px so
 * the user's question and the assistant's answer land in the same vertical
 * stripe on a wide monitor instead of spreading to opposite edges of the
 * chat pane. The user bubble stays right-aligned *within* that column.
 *
 * Assistant prose is also capped (via `.markdown > p|ul|...` in index.css)
 * but code blocks, tables, and the Sources panel are intentionally allowed
 * to break out and use the full row width — they need the room.
 */
export function MessageView({ role, content, status, meta, ...rest }: Message) {
  if (role === 'user') {
    return (
      <div className="message-row message-row--user mb-4">
        <div className="bg-primary text-white rounded-lg px-4 py-2 max-w-[80%]">{content}</div>
      </div>
    );
  }
  return (
    <div className="message-row mb-4">
      <AssistantHeader status={status} meta={meta} />
      <MessageBody content={content} status={status} meta={meta} {...rest} />
    </div>
  );
}
